<template>
  <div class="xypj-box">
    <div v-if="declareTemplate" class="top-box">
      <div>
        <b>{{ declareTemplate.sbnd }}</b
        >年度{{ declareTemplate.name }}申报开始啦！申报时间：{{
          declareTemplate.startTime
        }}~{{ declareTemplate.endTime }}
      </div>
      <div>
        <el-button type="text" @click="downloadFile">评价资料下载</el-button>
        <el-button
            :disabled="declareTemplate.declareStatus !== 0"
            type="primary"
            @click="addHandle"
        >立即申报
        </el-button>
      </div>
    </div>
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column
          align="center"
          label="申报年度"
          prop="template.sbnd"
          show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
          align="center"
          label="申报名称"
          prop="template.name"
          show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
          align="center"
          label="申报时间"
          prop="createTime"
          show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
          align="center"
          label="自评分"
          prop="zpScore"
          show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
          align="center"
          label="初审得分"
          prop="csScore"
          show-overflow-tooltip
      >
        <template #default="scope">
          {{ scope.row.csScore ? scope.row.csScore : "--" }}
        </template>
      </el-table-column>
      <el-table-column
          align="center"
          label="终审得分"
          prop="zsScore"
          show-overflow-tooltip
      >
        <template #default="scope">
          {{ scope.row.zsScore ? scope.row.zsScore : "--" }}
        </template>
      </el-table-column>
      <el-table-column
          align="center"
          label="信用等级"
          prop="xyjb"
          show-overflow-tooltip
      >
        <template #default="scope">
          {{ scope.row.xyjb ? scope.row.xyjb : "--" }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态" prop="status">
        <template #default="scope">
          {{
            scope.row.status != null
                ? statusType.find((item) => item.value === scope.row.status).label
                : ""
          }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作">
        <template #default="scope">
          <el-button
              size="small"
              type="text"
              @click="handleClick(scope.row, 'look')"
          >查看详情
          </el-button>
          <el-button
              v-if="scope.row.status != 0"
              size="small"
              type="text"
              @click="reviewProgressClick(scope.row)"
          >
            评审进度
          </el-button>
          <el-button
              v-if="scope.row.status == 0 || scope.row.status == -1"
              size="small"
              type="text"
              @click="handleClick(scope.row, 'edit')"
          >修改资料
          </el-button>
          <el-button
              v-if="scope.row.status == 2"
              size="small"
              type="text"
              @click="handleClick(scope.row, 'look', 'bczl')"
          >补充资料
          </el-button>
          <ImageViewer
              v-if="scope.row.status == 4"
              :btnText="'查看证书'"
              :on-close="closeViewer"
              :url="getImgToken(scope.row.certUrl)"
          ></ImageViewer>
        </template>
      </el-table-column>
    </el-table>
    <XypjDetails :details="details" @handleClose="handleClose"></XypjDetails>
    <ReviewProgress
        :details="ReviewProgressDetails"
        @handleClose="handleClose"
    ></ReviewProgress>
  </div>
</template>
<script>
import XypjDetails from "./details.vue";
import ReviewProgress from "./ReviewProgress.vue";
import ImageViewer from "@/components/image-viewer.vue";
import {
  getDeclareRecordApi,
  getDeclareTemplateApi,
  getDownloadFileApi,
} from "@/api/home";

export default {
  components: {XypjDetails, ReviewProgress, ImageViewer},
  data() {
    return {
      tableData: [],
      statusType: [
        {
          label: "草稿",
          value: 0,
        },
        {
          label: "待初审",
          value: 1,
        },
        {
          label: "待终审",
          value: 2,
        },
        {
          label: "评审完成",
          value: 3,
        },
        {
          label: "公示完成",
          value: 4,
        },
        {
          label: "已退回",
          value: -1,
        },
        {
          label: "取消资格",
          value: -2,
        },
      ],
      details: {
        dialogVisible: false,
        title: "填报",
        type: "add",
        typeBczl: "",
        data: {},
      },
      ReviewProgressDetails: {
        dialogVisible: false,
        title: "评审进度",
        data: {},
      },
      xh_userInfo: {},
      declareTemplate: {},
      msgBccl: {
        isShow: true,
        mes: "",
      }, // 补充材料提示
      srcList: [],
      url: "",
      visible: false,
      showViewer: false,
    };
  },
  mounted() {
    this.xh_userInfo = JSON.parse(this.$Cookies.get("xh_userInfo"));
    this.getDeclareTemplate();
    this.getDeclareRecord();
  },
  methods: {
    // 关闭查看器
    closeViewer() {
      this.showViewer = false;
    },
    getImgToken(imgUrl) {
      let token = JSON.parse(this.$Cookies.get("xh_userInfo")).token;
      if (!imgUrl) {
        return imgUrl;
      }
      let urlStr = this.$previewImg + imgUrl + "?token=" + token;
      return urlStr;
    },
    handleClick(row, type, typeBczl) {
      console.log("row", row);
      // 修改资料
      this.details.dialogVisible = true;
      this.details.data.id = row.id;
      this.details.data.remark = row.template.remark;
      this.details.data.cnsUrl = row.cnsUrl; // 承诺书附件资料
      this.details.data.cnsName = row.cnsName; // 承诺书附件资料
      this.details.data.status = row.status; // 状态
      this.details.data.userName = row.userName; // 填报人姓名
      this.details.data.phone = row.phone; // 填报人姓名
      // this.details.data.attachNum = row.attachNum; // 对应资料数量
      // this.details.data.complementNum = row.complementNum; // 补充资料数量
      this.details.type = type;
      this.details.typeBczl = typeBczl;
    },
    reviewProgressClick(row) {
      this.ReviewProgressDetails.dialogVisible = true;
      this.ReviewProgressDetails.data.id = row.id;
    },
    addHandle() {
      // 立即申报
      this.details.dialogVisible = true;
      this.details.data.id = this.declareTemplate.id;
      this.details.type = "add";
    },
    // 评价资料下载
    downloadFile() {
      getDownloadFileApi({type: 16}).then((res) => {
        console.log("res", res.result);
        window.open(res.result.resource + "?attname=信用评价模板.xlsx");
      });
    },
    handleClose() {
      this.details.dialogVisible = false;
      this.ReviewProgressDetails.dialogVisible = false;
      this.getDeclareTemplate();
      this.getDeclareRecord();
    },
    getDeclareTemplate() {
      getDeclareTemplateApi({token: this.xh_userInfo.token}).then((res) => {
        if (res.code === 200) {
          this.declareTemplate = res.result;
          this.details.data.remark = res.result ? res.result.remark : "";
        }
      });
    },
    // 获取列表分页
    getDeclareRecord() {
      getDeclareRecordApi({token: this.xh_userInfo.token}).then((res) => {
        if (res.code === 200) {
          this.tableData = res.result ? res.result.declareRecords : [];
          if (res.result && res.result.msg) {
            // 判断是否有补充材料提示
            this.msgBccl.mes = res.result ? res.result.msg : "";
            if (!this.msgBccl.isShow) return;
            this.msgBcclOpen();
            this.msgBccl.isShow = false;
          }
        }
      });
    },
    msgBcclOpen() {
      this.$alert(
          `<div style="color: red">&nbsp;&nbsp;&nbsp;&nbsp;${this.msgBccl.mes}</div>`,
          "提示",
          {
            confirmButtonText: "关闭",
            dangerouslyUseHTMLString: true,
          },
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.xypj-box {
  min-height: 500px;

  table {
    width: 100%; /* 表格宽度 */
    border-collapse: collapse; /* 边框合并为一个单一的边框 */
    margin: 20px 0; /* 上下外边距 */
  }

  th,
  td {
    border: 1px solid #ddd; /* 单元格边框 */
    padding: 8px; /* 单元格内边距 */
    text-align: left; /* 文本左对齐 */
  }

  th {
    background-color: #f2f2f2; /* 表头背景色 */
    color: #333; /* 表头文字颜色 */
  }
}

.top-box {
  color: #f56c6c;
  padding: 10px;
  font-size: 18px;
  font-weight: bold;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
</style>
